module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"Ditt kupongbelopp","track":"Your voucher amount"}}